import { render } from "./VitDropdown.vue?vue&type=template&id=3722c79c&ts=true"
import script from "./VitDropdown.vue?vue&type=script&lang=ts"
export * from "./VitDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__